<template>
  <a-card :bordered="false">
    <template v-if="this.departId">
      <a-spin :spinning="loading">
        <a-form-model ref="formModel" :model="model" :rules="formModelRules" :colon="true">
          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userIdCreateType" :label="$t('用户编号生成')">
            <a-radio-group v-model="model.userIdCreateType" :placeholder="$t('请选择生成方式')">
              <a-radio :value="0">
                {{ $t('手动输入') }}
              </a-radio>
              <a-radio :value="1">
                {{ $t('自动生成') }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <template v-if="model.userIdCreateType == 1">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userIdCreatePrefix" :label="$t('用户编号前缀')">
              <a-input :placeholder="$t('请输入用户编号前缀')" v-model="model.userIdCreatePrefix" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userIdCreateLen" :label="$t('用户编号长度')">
              <a-select v-model="model.userIdCreateLen" :placeholder="$t('请选择用户编号长度')"
                :getPopupContainer="(target) => target.parentNode" @change="changeUserIdCreateLen">
                <a-select-option v-for="item in 6" :key="item" :value="item+4">{{item+4}}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userIdCreateCurrent" :label="$t('当前用户编号')">
              <a-input :placeholder="$t('请输入当前用户编号')" :maxLength="model.userIdCreateLen" v-model="model.userIdCreateCurrent" />
            </a-form-model-item>
          </template>
          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark" :label="$t('备注')">
            <a-textarea :placeholder="$t('请输入备注')" v-model="model.remark" />
          </a-form-model-item>
          <div>
            <a-divider orientation="left">
              {{ $t('用户编号说明') }}
            </a-divider>
            <p>{{ $t('1.用户编号格式为用户编号前缀+当前用户编号；') }}</p>
            <p>{{ $t('2.当前用户编号长度不够设置的编号长度时自动在编号前补0；') }}</p>
            <p>{{ $t('3.例如：用户编号前缀为MX,用户编号长度为8，当前用户编号为1；那么当选中“用户编号自动生成”功能后，系统生成的用户编号为MX00000001；') }}</p>
          </div>
        </a-form-model>
      </a-spin>
      <div class="anty-form-btn">
        <a-button style="float: right" @click="handleSubmit" type="primary" htmlType="button" icon="form">{{ $t('保存') }}</a-button>
      </div>
    </template>
    <a-card v-else :bordered="false" style="height:200px">
      <a-empty>
        <span slot="description"> {{ $t('请先选择一个部门!') }} </span>
      </a-empty>
    </a-card>
  </a-card>
</template>

<script>
  import {
    getAction,
    httpAction,
  } from '@/api/manage'
  import {
    IntegerWithZeroPattern
  } from '@/utils/regPattern'
  export default {
    name: 'DepartUserIdCreateRuleModal',
    components: {},
    data() {
      return {
        departId: "",
        treeData: [],
        title: this.$t("用户编号规则配置"),
        visible: false,
        loading: false,
        model: {
          userIdCreateType: 0,
          userIdCreatePrefix: '',
          userIdCreateLen: 8,

        },
        labelCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 5
          }
        },
        wrapperCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 16
          }
        },
        url: {
          add: "/jeecg-charge/meter/departUserIdConfig/add",
          edit: "/jeecg-charge/meter/departUserIdConfig/edit",
          list: "/jeecg-charge/meter/departUserIdConfig/list",
        },
      }
    },
    computed: {
      // i18n：校验规则使用 computed 以响应语言切换
      formModelRules() {
        return {
          userIdCreateType: [{
            required: true,
            message: this.$t('请选择用户编号生成规则')
          }],
          userIdCreateLen: [{
            required: true,
            message: this.$t('请选择用户编号长度')
          }],
          userIdCreateCurrent: [{
              required: true,
              message: this.$t('请输入当前用户编号')
            },
            {
              pattern: IntegerWithZeroPattern,
              message: this.$t('用户编号只能输入数字')
            },
            {
              max: 8,
              message: this.$t('用户编号长度超限')
            },
          ],
        }
      },
    },
    methods: {
      show(departId) {
        this.departId = departId;
        this.model = this.$options.data.call(this).model;
        this.loadData();
      },
      close() {
        this.reset()
        this.$emit('close');
        this.visible = false;
      },
      reset() {
        this.loading = false
      },
      handleCancel() {
        this.close()
      },
      handleSubmit() {
        if (!this.departId) {
          this.$message.warning(this.$t('请点击选择一个部门!'))
        }
        this.$refs.formModel.validate(valid => {
          if (valid) {
            this.loading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            let formData = Object.assign({
              departId: this.departId
            }, this.model);
            let that = this;
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData();
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      loadData() {
        this.loading = true;
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.departId = this.departId;
        getAction(this.url.list, params).then((res) => {
          if (res.success && res.result.records.length > 0) {
            this.model = res.result.records[0]
          }
        }).finally(() => {
          this.loading = false;
        })
      },
      changeUserIdCreateLen(value) {
        console.log( this.formModelRules.userIdCreateCurrent)
        this.formModelRules.userIdCreateCurrent[2].max = this.model.userIdCreateLen;
        this.$refs.formModel.validateField(['userIdCreateCurrent'],{force: true})
      }
    },
  }
</script>

<style scoped>

</style>